import React, { FC } from 'react'
import { Field } from 'react-final-form'
import TextField from '../../../components/fields/TextField'
import { Grid } from '@mui/material'
import FormPhoneField from '../../../components/fields/FormPhoneField'
import { ContactFormValuesEnum } from '../types/contactFormValuesEnum'
import OriginField from './OriginField'

const AccountForm: FC = () => {
	const onPaste = (event: React.ClipboardEvent<HTMLDivElement>) => {
		event.preventDefault()
		return false
	}

	return (
		<Grid container item spacing="40px">
			<Grid container item>
				<Field
					name={ContactFormValuesEnum.SOCIAL_REASON}
					component={TextField}
					label="creationContact.contactForm.socialReason"
					inputOnPaste={onPaste}
					maxLength={255}
				/>
			</Grid>
			<Grid container item>
				<Field
					name={ContactFormValuesEnum.EMAIL}
					component={TextField}
					label="creationContact.contactForm.email"
				/>
			</Grid>
			<Grid container item>
				<Field
					name={ContactFormValuesEnum.MOBILE}
					component={FormPhoneField}
					label="creationContact.contactForm.phoneFix"
				/>
			</Grid>
			<Grid container item>
				<OriginField />
			</Grid>
		</Grid>
	)
}

export default AccountForm